import { render, staticRenderFns } from "./archivItem.vue?vue&type=template&id=222a08db&scoped=true&"
import script from "./archivItem.vue?vue&type=script&lang=js&"
export * from "./archivItem.vue?vue&type=script&lang=js&"
import style0 from "./archivItem.vue?vue&type=style&index=0&id=222a08db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a08db",
  null
  
)

export default component.exports